// Selectable error block with a Copy button — failures here are usually a
// server message worth pasting somewhere, which a toast string can't be.
import React, { useState } from "react";
import PropTypes from "prop-types";
import { Box, IconButton, Tooltip } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import SoftTypography from "components/SoftTypography";
import { cc } from "afms/theme/commandCenterTheme";

export default function CopyableError({ message }) {
  const [copied, setCopied] = useState(false);
  if (!message) return null;

  const copy = () => {
    const done = () => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    };
    if (navigator?.clipboard?.writeText) {
      navigator.clipboard.writeText(message).then(done).catch(() => {});
    } else {
      done();
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        gap: 1,
        p: 1.5,
        border: "1px solid #f5c2c2",
        borderRadius: "8px",
        bgcolor: "#fdecec",
      }}
    >
      <SoftTypography
        variant="caption"
        sx={{
          color: "#b91c1c",
          flex: 1,
          userSelect: "text",
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
        }}
      >
        {message}
      </SoftTypography>
      <Tooltip title={copied ? "Copied" : "Copy"}>
        <IconButton size="small" onClick={copy} sx={{ color: cc.muted }}>
          <ContentCopyIcon sx={{ fontSize: 16 }} />
        </IconButton>
      </Tooltip>
    </Box>
  );
}

CopyableError.propTypes = {
  message: PropTypes.string,
};

CopyableError.defaultProps = {
  message: null,
};
